import { render, staticRenderFns } from "./WorksheetNotes.vue?vue&type=template&id=c21157fa"
import script from "./WorksheetNotes.vue?vue&type=script&lang=js"
export * from "./WorksheetNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c21157fa')) {
      api.createRecord('c21157fa', component.options)
    } else {
      api.reload('c21157fa', component.options)
    }
    module.hot.accept("./WorksheetNotes.vue?vue&type=template&id=c21157fa", function () {
      api.rerender('c21157fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/processWorksheet/WorksheetNotes.vue"
export default component.exports